export const useStyles = theme => ({
    fieldsContainer: {
        marginBottom: '60px',
    },
    field: {
        width: '95%',
    },
    requiredAsterisk: {
        color: '#009f3c',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    nextButton: {
        boxShadow: 'none !important',
    },
    previousButton: {
        marginRight: '10px',
        boxShadow: 'none !important',
        border: '1px solid grey',
    },
    typeHeader : {
        fontWeight: 'bold',
        color: '#000',
        fontsize: '20px',
    },
    addIcon: {
        position: 'relative',
        top: '2px',
        left: '5px',
        color: '#009f3c',
        fontSize: '15px',
        fontWeight: 'bold',
        marginRight: '5px',
    },
    selectButton: {
        color: '#787878',
        width: '100%'
    },
    dateFont: {
        color: "#787878",
        fontSize: "0.8em",
        marginLeft: '10px',
    },
    dialogPaper: {
        minHeight: '70vh',
        minWidth: '60vh',
    },
    gamelist: {
        maxHeight: '60vh',
        overflow: 'auto'
    },
    gameLabel: {
        fontsize: '14px',
        color: '#263238',
        fontWeight: 'bold',
    },
    addGameButton: {
        paddingLeft: '16px',
        color: '#009F3C',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    removeButton: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#009F3C',
        cursor: 'pointer',
        paddingLeft: '10px',
    }
});